import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class AdminProfitRoute extends RouteBase {
  prefix = 'admin.statistics.profits.'

  index() {
    return this.ziggyRoute('index')
  }

  store() {
    return this.ziggyRoute('store')
  }

  update(profitId: number) {
    return this.ziggyRoute('update', profitId)
  }
}
